import React from 'react';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import Body from '../Components/layout/Body';
import ReviewRow from '../Components/layout/ReviewRow';
import { extractActivityButtons, isActivityLowTech } from './ConstActivityBtns';
import { PLATFORM_BUTTONS } from './ConstPlatformBtns';
import { SUBTABS, GOALS_STEPS } from './ConstPaths';
import './Views.scss';

//the props should have been picked before getting to review,
//so make them all required (except name, which is always optional)
const propTypes = {
  firstName: PropTypes.string,
  mainGoal: PropTypes.string.isRequired,
  activities: PropTypes.arrayOf(PropTypes.string).isRequired,
  priority: PropTypes.string.isRequired,
  platforms: PropTypes.arrayOf(PropTypes.string).isRequired,
  onContinue: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
};

//content sub-component with unique content for this page
function GoalsReviewContent(props) {
  const activities = props.activities;
  const priority = props.priority;
  const platforms = props.platforms;

  console.log("rendering GatherInfoGoalsReviewForm, platforms: " + platforms);

  let activityBtns = extractActivityButtons();
  let skipPlatforms = isActivityLowTech(priority);

  const BASE_URL = SUBTABS.GOALS + "/";
  const steps = GOALS_STEPS;

  return(
  <Row>
    <Col>
      <ReviewRow 
        heading="Activities" 
        nextRoute={BASE_URL+steps.ACTIVITIES}
        values={activities}
        lookup={activityBtns}
      />
      <ReviewRow 
        heading="Priority activity" 
        nextRoute={BASE_URL+steps.PRIORITY}
        values={priority}
        lookup={activityBtns}
      />
      <ReviewRow 
        heading="Platforms" 
        nextRoute={BASE_URL+steps.PLATFORMS}
        values={platforms}
        lookup={PLATFORM_BUTTONS}
        skipWarning={skipPlatforms}
      />
    </Col>
    <Col lg={2}></Col>
  </Row>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component.
//since the main goal step includes a form, receive the initial form values via props,
//along with setters to change those values based on the form input.
function GatherInfoGoalsReview(props) {
  const firstName = props.firstName;
  const mainGoal = props.mainGoal;
  const activities = props.activities;
  const priority = props.priority;
  const platforms = props.platforms;
  const onContinue = props.onContinue;

  console.log("rendering GatherInfoGoalsReview");

  const pageData = {
    image: "", //not yet used
    faIcon: "",
    pageSymbolClassName: "aa-section-symbol gather",
    title: `Review ${firstName}'s Goals and Needs`,
    subTitle: "Good job! Setting goals can be hard work. Here's what we've got:",
    learnMore: {linkText: "",
                title: "",
                content: ""
                },
    nextRoute: "", //not used since we have an onContinue callback
    sidebar: false
  }

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <GoalsReviewContent 
          mainGoal={mainGoal} 
          activities={activities} 
          priority={priority}
          platforms={platforms}
        />
      }
      onContinue={onContinue} 
    />
    </>
  );
}

GatherInfoGoalsReview.propTypes = propTypes;
GatherInfoGoalsReview.defaultProps = defaultProps;

export default GatherInfoGoalsReview;